import { ILinkedData } from '../../interface/linked-data.interface';
import { isNumber, isString } from 'lodash';
import { DraftMentionFormatterType } from '../../interface/draft/draft-mention-formatter.type';
import * as moment from 'moment';
import { DesignObjectMentionMetadataType } from '../../enum/page-mention-metadata-type.enum';
import { AppStateModel } from '../../model/app-state.model';
import * as draftToHtml from 'draftjs-to-html';
import {renderDraftToHTML} from './render-draft-to-html.util';
import {toJS} from 'mobx';

export const printValue = (state: AppStateModel, mention: ILinkedData, formatter: DraftMentionFormatterType, blockMentionData: { [ key: string ]: any }) => {
  if (isString(mention.data) || isNumber(mention.data)) {
    if (formatter[ mention.type ]) {
      let data = String(mention.data);
      if (mention.type === DesignObjectMentionMetadataType.Date) {
        let date;
        try {
          date = moment.utc(data);
          if (!date.isValid()) {
            date = moment();
          }
        } catch (e) {
          date = moment();
        }
        data = date.format('YYYY-MM-DDTHH:mm:ss');
      }
      return formatter[ mention.type ](data, state);
    }
    return mention.data;
  } else {
    return draftToHtml(toJS(mention.data), undefined, undefined, renderDraftToHTML(state, formatter, false, blockMentionData));
  }
};
